export enum ProcessoIdentificacaoPeticaoInicialSituacao {
  AGENDADA = 'AGENDADA',
  AUSENTE = 'AUSENTE',
  FALHA_PROCESSAMENTO = 'FALHA_PROCESSAMENTO',
  IDENTIFICADA = 'IDENTIFICADA',
  PENDENTE = 'PENDENTE'
}
